// extracted by mini-css-extract-plugin
export var container = "search-widget-module--container--zIhZi";
export var dropdown = "search-widget-module--dropdown--4sfdw";
export var errorMessage = "search-widget-module--error-message--Q-Rm0";
export var loader = "search-widget-module--loader--bPJxv";
export var noResultsMessage = "search-widget-module--no-results-message--+o2Qv";
export var searchItem = "search-widget-module--search-item--wIcF3";